"use no memo";

import type { LinkComponentProps } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import type { Row } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";
import { Fragment } from "react";

import type { features } from "~/components/common/tickets/ticket-list";
import type { Ticket } from "~/stores/tickets-store";

type TicketListItemProps = {
  row: Row<typeof features, Ticket>;
} & LinkComponentProps;

export function TicketListItem({ row, ...props }: TicketListItemProps) {
  const visibleCells = row.getVisibleCells();
  return (
    <Link
      tabIndex={0}
      to="/ticket/$ticketId"
      params={{
        ticketId: row.original.id,
      }}
      data-slot="data-list-row"
      className="hover:bg-sidebar/50 relative col-[1/_-1] grid h-11 w-full min-w-0 grid-cols-subgrid will-change-transform contain-style focus:shadow-[0_0_0_1px_var(--color-selected)_inset] focus:outline-none"
      {...props}
    >
      {visibleCells
        .filter((cell) => cell.column.columnDef.meta?.layout === "start")
        .map((cell) => (
          <Fragment key={cell.id}>
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </Fragment>
        ))}
      <div
        className="flex w-full min-w-0 items-center gap-2"
        data-list-grid-column="title"
      >
        <span className="gap-2 truncate">
          {visibleCells
            .filter((cell) => cell.column.columnDef.meta?.layout === "title")
            .map((cell) => (
              <Fragment key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </Fragment>
            ))}
        </span>
        <div className="contents">
          <div className="flex flex-[initial] grow flex-row"></div>
          {visibleCells.filter(
            (cell) => cell.column.columnDef.meta?.layout === "labels",
          ).length
            ? visibleCells
                .filter(
                  (cell) => cell.column.columnDef.meta?.layout === "labels",
                )
                .map((cell) => (
                  <Fragment key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </Fragment>
                ))
            : null}
          {visibleCells
            .filter(
              (cell) => cell.column.columnDef.meta?.layout === "orderFlow",
            )
            .map((cell) => (
              <Fragment key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </Fragment>
            ))}
          {visibleCells
            .filter((cell) => cell.column.columnDef.meta?.layout === "channel")
            .map((cell) => (
              <Fragment key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </Fragment>
            ))}
          {visibleCells
            .filter(
              (cell) => cell.column.columnDef.meta?.layout === "assignedTo",
            )
            .map((cell) => (
              <Fragment key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </Fragment>
            ))}
        </div>
      </div>
      {visibleCells
        .filter((cell) => cell.column.columnDef.meta?.layout === "end")
        .map((cell) => (
          <Fragment key={cell.id}>
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </Fragment>
        ))}
    </Link>
  );
}
